module.exports = "/images/trail-3.jpg";